module.exports = __webpack_public_path__ + "img/construction-workers-fabricating-steel-reinforcement-bar-construction-site.e212439f.jpg";